/** Reason a user is blocked from adding a new dependency, ordered by surfacing priority. */ export var DependencyAddBlockedReason = /*#__PURE__*/ function(DependencyAddBlockedReason) {
    DependencyAddBlockedReason["MissingPremiumLicense"] = "MissingPremiumLicense";
    DependencyAddBlockedReason["MissingStartAndFinishDates"] = "MissingStartAndFinishDates";
    DependencyAddBlockedReason["MissingStartDate"] = "MissingStartDate";
    DependencyAddBlockedReason["MissingFinishDate"] = "MissingFinishDate";
    DependencyAddBlockedReason["TaskLimitReached"] = "TaskLimitReached";
    DependencyAddBlockedReason["PlanLimitReached"] = "PlanLimitReached";
    DependencyAddBlockedReason["RelatedTasksNotAllowed"] = "RelatedTasksNotAllowed";
    DependencyAddBlockedReason["CreatesCircularDependency"] = "CreatesCircularDependency";
    return DependencyAddBlockedReason;
}({});
